<template lang="html">
    <div class="lotteryResume" v-show="detail.count_down !== 0">
        <div class="title">抽奖简介</div>
        <p>{{ detail.activity_introduction }}</p>

        <countDown ref="countDown" class="countDown" :timestamp="detail.count_down" @callBack="onCountDownCallBack" :hasDay="true">
            <van-icon class="icon" name="clock-o" color="#ffffff" size="14" />
            <p class="p1">剩</p>
            <div class="pBox">
                <p><span>{{ timeInfo.d }}</span>天<span>{{ timeInfo.h }}</span>:<span>{{ timeInfo.m }}</span>:<span>{{ timeInfo.s }}</span></p>
            </div>
        </countDown>
    </div>
</template>

<script>
import countDown from '@/components/countDown/countDown.vue'

export default {
    name: 'lotteryResume',
    props: {
        /* 服务详情数据 */
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
        countDown
    },
    data () {
        return {
            timeInfo: {
                d: 0,
                h: 0,
                m: 0,
                s: 0
            },
            remainTime: 0,
        }
    },
    beforeDestroy () {
        this.$refs.countDown.end()
    },
    mounted () {
    },
    methods: {
        /**
         * 开始倒计时
         */
        startCountDown () {
            this.$refs.countDown.end()
            this.$refs.countDown.start()
        },
        /**
         * 倒计时回调
         * @param {object} timeInfo
         */
        onCountDownCallBack (timeInfo) {
            this.timeInfo = timeInfo
            this.$emit('callBack', timeInfo)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.lotteryResume
    padding 0 30px 30px 30px
    position relative
    .title
        display inline-block
        text-align center
        border-radius 6px
        height 32px
        font-size 24px
        line-height 32px
        padding 4px 8px
        margin-bottom 23px
        color #ffffff
        background #999999
    p
        font-size 24px
        line-height 36px
        color #666666
    .countDown
        display flex
        justify-content center
        align-items center
        padding-right 10px
        position absolute
        top 0
        right 0
        height 42px
        vertical-align middle
        line-height 42px
        background #ff6600
        border-top-left-radius 25px
        border-bottom-left-radius 25px
        .icon
            margin 0 10px
        .p1
            vertical-align middle
            display inline-block
            color #ffffff
        .pBox
            vertical-align middle
            display inline-block
            // min-width 130px
            text-align left
            p
                color #ffffff
</style>
